import 'normalize.css';
import 'styles/global.scss';
import styles from './AppContainer.scss';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { locationShape } from 'react-router';
import { connect } from 'react-redux';
import {
    applicationInitialized,
    setApplicationConfig
} from 'common/actions/applicationContainer';
import { replace } from 'react-router-redux';
import lodash from 'lodash';
import { getAppConfig, getClientData } from 'common/util/configUtil';
import { login, getMeOnLogin, loginV4, onChallengeQuestionAnswer, setChallengeQuestionAnswer, setRegistrationPassword, onResetPassword } from 'common/actions/login';
import { addApplicationMessage } from 'common/actions/applicationMessagesActions';
import { SessionTunnel } from 'common/util/SessionTunnel';
import { Socket } from 'common/util/socket';
import { isMobile, isTablet } from 'common/util/mobile';
import { saveAuthCredentials, getAuthCredentials } from 'common/util/auth-storage';
import { getGlobalEventEmitter } from 'common/util/GlobalEventDistributor';
import { loadHomePageV4Access, studyFeatureAccess } from 'common/features/predicates';

import ApplicationHeader from 'common/components/ApplicationHeader/ApplicationHeader';
import ApplicationMessages from 'common/components/ApplicationMessages/ApplicationMessages';
import LoadingComponent from 'common/permissions/components/LoadingComponent';
import Modal from 'components/common/Modal/Modal';
import { Button, BUTTON } from 'components/common/Button/Button';
import LoginV4 from '../../components/Login/Loginv4';
import ResetPassword from '../../components/Login/ResetPassword';
import NewUser from '../../components/Login/NewUser';
import ExpiredPassword from '../../components/Login/ExpiredPassword';
const { SIZE, COLOR, BGCOLOR } = BUTTON;


export class AppContainer extends Component {
    constructor(...args) {
        super(...args);
        this.loadAppConfig();
        this.state = {
            subscribedToSession: false,
            subscribedToActiveConversionInterupt: false
        };
        this.sessionTunnel = new SessionTunnel(this.context.store, new Socket());
        this.setSessionTimeoutWarning = this.sessionTunnel.on('sessionTimeoutWarning',
            () => this.callActionOnModal('sessionTimeoutWarningModal', 'open'));
        this.clearSessionTimeoutWarning = this.sessionTunnel.on('sessionExtended',
            () => this.callActionOnModal('sessionTimeoutWarningModal', 'close'));
    }

    componentDidMount() {
        this.sessionTunnel.subscribe();
        this.loadMe();
        this.redirectToOverview(this.props);
        this.logoutMessageIfNeeded();
        this.checkAuthCredentials();
        this.props.applicationInitialized();
    }

    loadMe() {
        const { token, sub } = this.props;
        const authCreds = getAuthCredentials();
        if (authCreds && (!token || !sub)) {
            this.initializeSessionTunnel(authCreds.sub);
            this.props.getMeOnLogin();
        }
    }

    callActionOnModal(modalReference, action) {
        if (!lodash.isNil(this.refs[modalReference])) {
            this.refs[modalReference][action]();
        }
    }

    expireSession() {
        this.sessionTunnel.expireSession();
    }

    componentWillReceiveProps(nextProps) {
        // const { replace, location } = this.props;
        const { location } = this.props;
        const { me, location: nextLocation } = nextProps;

        if (me && !me.hasCompletedRegistration && location.pathname !== '/registration') {
            if (location.pathname.includes('/reset-password')) {
                return <ResetPassword onChallengeQuestionAnswer={this.onChallengeQuestionAnswer.bind(this)} onResetPassword={this.onResetPassword.bind(this)} />;
            }
            else {
                window.location.href = '/registration';
                return null;
            }

        }
        if (me && nextLocation.pathname === '/') {
            this.redirectToOverview(nextProps);
            return;
        }
        if (nextLocation.pathname === '/logout') {
            this.expireSession();
        }
        if (nextProps.loginStatus) {
            const authCreds = getAuthCredentials();

            this.initializeSessionTunnel(authCreds.sub);
            this.registerActiveConversionListener();
        }
        if (me && !lodash.isNil(lodash.get(me, 'logoutLandingPage'))) {
            const logoutLandingURL = String(lodash.get(me, 'logoutLandingPage')).toLowerCase();

            this.sessionTunnel.setSSOLogoutLandingPage(logoutLandingURL);
        }
    }

    registerActiveConversionListener() {
        const { subscribedToActiveConversionInterupt } = this.state;
        if (!subscribedToActiveConversionInterupt) {
            const globalEventDistributor = getGlobalEventEmitter();
            globalEventDistributor.on('ActiveConversionInteruptWarning',
                () => this.callActionOnModal('activeConversionModal', 'open'));
            this.setState({ subscribedToActiveConversionInterupt: true });
        }
    }

    interuptActiveConversion() {
        this.callActionOnModal('activeConversionModal', 'close');
        this.expireSession();
    }

    initializeSessionTunnel(sub) {
        const { subscribedToSession } = this.state;
        if (!subscribedToSession) {
            this.sessionTunnel.initializeSessionTunnel(sub);
            this.setState({ subscribedToSession: true });
        }
    }


    redirectToOverview(props) {
        const { replace } = props;
        const redirectQueryString = lodash.get(props, 'location.query.redirect');

        if (!lodash.isEmpty(lodash.get(props, 'me', null))) {
            const homePage = '/binders';

            if (redirectQueryString) {
                return replace(redirectQueryString);
            }
            return replace(isMobile() || isTablet() ? '/tasks' : homePage);
        }
    }

    logoutMessageIfNeeded() {
        const {
            addApplicationMessage,
            isRedirectForExpiredSession
        } = this.props;

        if (isRedirectForExpiredSession) {
            addApplicationMessage('info', 'Your session has expired.');
        }
    }

    checkAuthCredentials() {
        const { token, sub, pdftron, getMeOnLogin } = this.props;
        const previousUserAuthCreds = getAuthCredentials();
        if (!token || !sub) {
            return;
        }
        saveAuthCredentials({ accessToken: token, sub, pdftronLicense: window.btoa(pdftron) });
        this.initializeSessionTunnel(sub);
        if (previousUserAuthCreds && (previousUserAuthCreds.sub !== sub)) {
            this.sessionTunnel.changeTerminal(previousUserAuthCreds);
        }
        getMeOnLogin();
    }

    componentWillUnmount() {
        this.sessionTunnel.unsubscribe();
    }

    async loadAppConfig() {
        const {
            setApplicationConfig
        } = this.props;
        setApplicationConfig({ ...getAppConfig(), ... await getClientData() });
    }

    getChildContext() {
        // Ensure route location is available in all components
        return { location: this.props.location };
    }

    login(e) {
        e.preventDefault();
        const sub = lodash.get(this.context, 'router.location.query.s', null);
        const loginMethodId = lodash.get(this.context, 'router.location.query.lmid', null);
        const previousUserAuthCreds = getAuthCredentials();
        this.props.login({ sub, loginMethodId }).then(() => {
            const newUserAuthCreds = getAuthCredentials();
            if (previousUserAuthCreds && newUserAuthCreds && previousUserAuthCreds.sub !== newUserAuthCreds.sub) {
                this.sessionTunnel.changeTerminal(previousUserAuthCreds);
            }
        });
    }

    loginV4(e, loginData, isWithEmail) {
        e.preventDefault();
        return this.props.loginV4(loginData, isWithEmail, SessionTunnel.logout.bind(this));
    }

    onChallengeQuestionAnswer(e, answer, params) {
        e.preventDefault();
        return this.props.onChallengeQuestionAnswer(answer, params);
    }

    setChallengeQuestionAnswer(e, params) {
        e.preventDefault();
        return this.props.setChallengeQuestionAnswer(params);
    }

    setRegistrationPassword(e, params) {
        e.preventDefault();
        return this.props.setRegistrationPassword(params);
    }

    onResetPassword(e, password, params) {
        e.preventDefault();
        return this.props.onResetPassword(password, params);
    }

    loadComponents() {
        const {
            me,
            loadingMe,
            location,
            initialized,
        } = this.props;

        if (location.pathname.includes('/new-user')) {
            return <NewUser setChallengeQuestionAnswer={this.setChallengeQuestionAnswer.bind(this)} setRegistrationPassword={this.setRegistrationPassword.bind(this)} />;
        }

        if (me || location.pathname === '/newUser' || location.pathname === '/forgot-password') {
            return this.props.children;
        }

        if (location.pathname.includes('/reset-password')) {
            return <ResetPassword onChallengeQuestionAnswer={this.onChallengeQuestionAnswer.bind(this)} onResetPassword={this.onResetPassword.bind(this)} />;
        }
        if (location.pathname.includes('/expired-password')) {
            return <ExpiredPassword onChallengeQuestionAnswer={this.onChallengeQuestionAnswer.bind(this)} onResetPassword={this.onResetPassword.bind(this)} />;
        }
        if (loadingMe || !initialized) {
            return <LoadingComponent />;
        }
        // return <Login onLogin={this.login.bind(this)} />;
        return <LoginV4 onLogin={this.loginV4.bind(this)} searchParms={lodash.get(this.context, 'router.location.query', null)} />;
    }

    render() {
        if (this.props.me !== undefined) {
            const institutionSessionProperty = lodash.find(this.props.me.institution.properties, { 'type': 'SessionTTL' });
            // default to 20 minutes (20 * 60)
            const sessionTtl = institutionSessionProperty ? institutionSessionProperty.value : '1200';
            // convert session timeout in seconds
            // to warning banner timeout in miliseconds (minus two minutes)
            const miliseccondsSessionTtl = (lodash.toSafeInteger(sessionTtl) - 120) * 1000;
            this.sessionTunnel.setSessionTimeoutWarning(miliseccondsSessionTtl);
        }

        return (
            <div className={styles.application} data-cy="AppContainer-return">
                {!(window.location.pathname.includes('/registration')
                    || window.location.pathname.includes('/reset-password')
                    || window.location.pathname.includes('/forgot-password')) && this.props.me && this.props.me.hasCompletedRegistration && <ApplicationHeader />}
                {this.loadComponents()}
                {getSessionTimeoutWarningModal(
                    () => this.callActionOnModal('sessionTimeoutWarningModal', 'close'),
                    () => this.expireSession.call(this))}
                {getActiveConversionsModal(
                    () => this.interuptActiveConversion(),
                    () => this.callActionOnModal('activeConversionModal', 'close'))}
                <ApplicationMessages />
            </div>
        );
    }
}

AppContainer.contextTypes = {
    store: PropTypes.any,
    router: PropTypes.any
};

AppContainer.childContextTypes = {
    location: locationShape
};

export default connect((state, props) => {
    return {
        me: lodash.get(state, 'me'),
        loadingMe: lodash.get(state, 'app.loadingMe', false),
        loginStatus: lodash.get(state, 'app.loginStatus', false),
        isRedirectForExpiredSession: lodash.get(props, 'location.query.expiredSession', false),
        token: lodash.get(props, 'location.query.token'),
        sub: lodash.get(props, 'location.query.sub'),
        pdftron: lodash.get(props, 'location.query.pdftron'),
        initialized: lodash.get(state, 'application.initialized'),
        studyFeatureAccess: studyFeatureAccess(state),
        homePageV4Access: loadHomePageV4Access(state),
    };
}, {
    getMeOnLogin,
    replace,
    addApplicationMessage,
    login,
    loginV4,
    onChallengeQuestionAnswer,
    setChallengeQuestionAnswer,
    setRegistrationPassword,
    onResetPassword,
    applicationInitialized,
    setApplicationConfig
})(AppContainer);


function getSessionTimeoutWarningModal(leftButtonAction, rightButtonAction) {
    return (
        <Modal ref="sessionTimeoutWarningModal" title={'Automatically Logging Out Soon'} data-cy="AppContainer-Modal">
            <div>
                <p data-test-id="warning-modal-text" className={styles.Modal__body__heading}>For security purposes, you are about to be logged-out due to inactivity.</p>

                <div className={styles.Modal__body__content}>
                    <p>Continue your session by dismissing this window, or selecting <span>'Stay Logged In'</span>.</p>
                    <p>End your session immediately by selecting <span>'Log Me Out'</span>.</p>
                    <p>Or, do nothing and your session will end automatically.</p>
                </div>
            </div>
            <div className={styles.modal__actions}>
                <span>
                    <Button
                        text={'Stay Logged In'}
                        className={styles.modal__button__left}
                        type={SIZE.SECONDARY}
                        onClick={() => leftButtonAction()}
                        data-cy="AppContainer-leftButtonAction" />
                </span>

                <span>
                    <Button
                        text={'Log Me Out'}
                        type={SIZE.SECONDARY}
                        bgcolor={BGCOLOR.ORANGE}
                        color={COLOR.WHITE}
                        onClick={() => rightButtonAction()}
                        data-cy="AppContainer-rightButtonAction" />
                </span>
            </div>
        </Modal>
    );
}

function getActiveConversionsModal(leftButtonAction, rightButtonAction) {
    return (
        <Modal ref="activeConversionModal" title={'You are currently adding documents to Complion.'}>
            <div className={styles.modal__body}>
                <b>If you exit now your documents will not be added.</b>
                <p>Would you like to stop adding these documents and exit Complion now?</p>
            </div>

            <div className={styles.modal__actions}>
                <span>
                    <Button
                        text={'Stop Adding and Exit Now'}
                        className={styles.modal__button__left}
                        type={SIZE.SECONDARY}
                        color={COLOR.RED}
                        onClick={() => leftButtonAction()}
                        data-cy="AppContainer-leftButtonActions" />
                </span>

                <span>
                    <Button
                        text={'Continue Adding'}
                        type={SIZE.SECONDARY}
                        bgcolor={BGCOLOR.ORANGE}
                        color={COLOR.WHITE}
                        onClick={() => rightButtonAction()}
                        data-cy="AppContainer-rightButtonActions" />
                </span>
            </div>
        </Modal>
    );
}
